
class Residue {
    constructor(pdbid, chainid, seqno, reslabel, resinsert) {
        this.pdbid = pdbid
        this.chainid = chainid
        this.seqno = seqno
        this.reslabel = reslabel
        this.resinsert = resinsert
    }
}

export default Residue;